// Proxy login (username + password, or an IP whitelist) as the login windows edit it, and as the API takes it
// (auth_user "user:pass", auth_ips "1.1.1.1,2.2.2.2"). Same rules as before: letters and numbers only.
const NAME = /^[a-zA-Z0-9]+$/;
const IPV4 = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;

export const splitIps = (text) => String(text || '').split(/[\s,;]+/).map((x) => x.trim()).filter(Boolean);
export const nameOk = (v, min = 1) => NAME.test(String(v || '')) && String(v).length >= min;
export const ipOk = (v) => IPV4.test(String(v || '').trim());

// a random login like the old refresh button made: u + 7 letters/digits, p + 7 digits
export function randomLogin() {
    const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let user = 'u', pass = 'p';
    for (let i = 0; i < 7; i++) user += chars.charAt(Math.floor(Math.random() * chars.length));
    for (let i = 0; i < 7; i++) pass += Math.floor(Math.random() * 10);
    return { user, pass };
}

// the window's state from a licence's login (or a fresh random login)
export function loginFrom(authUser, authIps) {
    const s = String(authUser || '');
    if (s.includes(':')) return { mode: 'login', user: s.slice(0, s.indexOf(':')), pass: s.slice(s.indexOf(':') + 1), ips: '' };
    const ips = splitIps(authIps);
    if (ips.length) return { mode: 'ips', ...randomLogin(), ips: ips.join('\n') };
    return { mode: 'login', ...randomLogin(), ips: '' };
}

export const loginValid = (m, min = 1) => (m && m.mode === 'ips'
    ? splitIps(m.ips).length > 0 && splitIps(m.ips).every(ipOk)
    : !!m && nameOk(m.user, min) && nameOk(m.pass, min));

// what the API takes: exactly one of the two is set
export const loginToAuth = (m) => (m.mode === 'ips'
    ? { auth_user: null, auth_ips: splitIps(m.ips).join(',') }
    : { auth_user: `${m.user}:${m.pass}`, auth_ips: null });
